let init = () => {
    let $components = document.querySelectorAll(".-js-read-more:not(.-js-upgraded)")

    for (let $component of $components) {
        let $link = $component.querySelector('.-js-read-more-link')
        let $content = $component.querySelector('.-js-read-more-content')

        if (!$link || !$content) {
            continue
        }

        let height = $content.offsetHeight

        $component.classList.add("-js-upgraded")

        if (height < $content.scrollHeight) {
            $component.classList.remove("-js-upgraded")
            continue
        }

        $link.addEventListener('click', (e) => {
            e.preventDefault()

            let height = $content.scrollHeight

            $content.style.height = height + 'px'

            $component.classList.add('-open')
        })
    }
}

export default { init }
